<template>
    <div class="main-container">
        <div class="filter-container">
            <el-input class="filter-item" v-model="filters.uuid" placeholder="请输入第三方渠道id(多个以逗号拼接)" style="width:300px"></el-input>
             <el-date-picker class="filter-item" v-model="filters.start_date" placeholder="选择开始日期" value-format="YYYY-MM-DD"></el-date-picker>
             <span class="filter-item">-</span>
             <el-date-picker class="filter-item" v-model="filters.end_date" placeholder="选择结束日期" value-format="YYYY-MM-DD"></el-date-picker>
            <el-select v-if="userType==1" class="filter-item" filterable v-model="filters.channel_no" placeholder="请选择渠道">
                <el-option v-for="item in channelList" :key="item.id" :label="item.channel_name" :value="item.channel_no"></el-option>
            </el-select>
            <el-button class="filter-btn" type="primary" @click="search()">搜索</el-button>
            <el-divider></el-divider>
            <div class="summary-box">
                <div class="summary-item">
                    <p class="label">充值总用户</p>
                    <p class="txt">{{summary.totalCount}}</p>
                </div>
                <div class="summary-item">
                    <p class="label">充值总金额 (元)</p>
                    <p class="txt">{{summary.totalMoney}}</p>
                </div>
            </div>
            <el-divider></el-divider>
        </div>
        <el-table :data="tableData" border>
            <el-table-column prop="uuid" label="第三方用户id"></el-table-column>
            <el-table-column prop="dgssid" label="蛋叔用户id"></el-table-column>
            <el-table-column prop="moneySum" label="充值总金额"></el-table-column>
            <el-table-column prop="username" label="昵称"></el-table-column>
            <el-table-column prop="user_money" label="用户余额"></el-table-column>
            <el-table-column prop="channel_no" label="渠道"></el-table-column>
            <el-table-column label="操作" width="190">
                <template #default="scope">
                    <div class="action-list">
                        <el-button type="primary" size="small" @click="router.push(`/partner/rechargeTotal-info?id=${scope.row.uuid}`)">充值详情</el-button>
                        <el-button type="primary" size="small" @click="router.push(`/partner/consumeTotal-info?id=${scope.row.dgssid}}`)">消费详情</el-button>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <Pagination :currentPage="filters.page" :total="total" @pageChange="onPageChange" @sizeChange="onSizeChange" />
        <!-- <el-pagination
            @current-change="handleCurrentChange"
            v-model:currentPage="filters.page"
            :page-size="filters.limit"
            layout="total, prev, pager, next, jumper"
            :total="total">
        </el-pagination> -->
    </div>
</template>

<script>
import Pagination from '@/components/Pagination.vue'
import { useRouter } from 'vue-router'
import { defineComponent, getCurrentInstance, toRefs, reactive } from 'vue'
import { useStore } from '@/store/index'
import Keys from '@/constant/key'
import { joinParams } from '@/utils/index'
export default defineComponent({
name: 'RechargeTotalList',
components: {Pagination},
setup() {
    const { proxy } = getCurrentInstance()
    const router = useRouter()
    const store = useStore()
    const userType = store.state.user.userInfo.user_type

    const state = reactive({
        filters: {
            uuid:       '', // 第三方渠道ID多渠道搜索，以逗号分隔
            channel_no: '', // 单渠道搜索渠道号
            start_date: '', // 开始日期
            end_date:   '', // 结束日期
            limit:      10, // 每页条数
            page:       1,  // 当前页码
        },
        tableData:  [], // 表格数据
        summary:    {}, // 概览数据
        channelList:[], // 渠道列表
        total:      0,  // 总条数
        
        // 获取表格数据
        getList(){
            proxy.$http.get(`/admin/recharge/getRechargeTotalList?${joinParams(state.filters)}`).then(res => {
                if(res.code == 0){
                    state.tableData = res.data.data;
                    state.summary = res.data.totalData;
                    state.total = res.count;
                }else{
                    state.tableData = [];
                }
            })
        },
        // 获取渠道列表
        getChannelList:()=>{
            proxy.$http.get(`/admin/user/getChannelList`).then((res) => {
                if(res.code == 0){
                    state.channelList = res.data;
                }else{
                    proxy.$message({type:'error',message:res.msg});
                }
            })
        },
        // 搜索
        search(){
            state.filters.page = 1
            state.getList();
        },
        // 分页
        onPageChange(val) {
            state.filters.page = val
            state.getList();
        },
        onSizeChange  (val) {
            state.filters.limit = val
            state.getList();
        },
    })
    state.getList()
    userType==1 && state.getChannelList() // 当前用户未绑定关联渠道为管理员，需要请求渠道列表

    return { ...toRefs(state), Keys, store, userType, router }
}
})
</script>

<style lang="stylus" scoped>
    .summary-box
        display flex
        justify-content space-around
    .summary-item
        text-align center
        .label
            font-size 18px
        .txt
            font-size 16px
            font-weight bold
            margin-top 20px
            color #666666
</style>